import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Typography } from '@mui/material';

const CheckInDataGrid = ({ rowsData, columns, openRefCheckInForm, loaderSkeleton }) => {
    return (
        <>
            <Typography
                variant="h6"
                textAlign='center'
                gutterBottom
                component="div"
            >
                Monthly 1:1
            </Typography>
            <DataGrid
                rows={rowsData}
                columns={columns}
                disableColumnResize={true}
                onRowClick={(params) => openRefCheckInForm(params.row.id)}
                rowSelection={false}
                loading={loaderSkeleton}
                localeText={{ noRowsLabel: "No Reviews" }}
                slotProps={{
                    loadingOverlay: {
                        variant: 'skeleton',
                        noRowsVariant: 'skeleton',
                    }
                }}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 4,
                            page: 0
                        },
                    },
                }}
                pageSizeOptions={[5,10]}
                // paginationModel={pagination}
                // onPaginationModelChange={(params) => setPagination((prev) => ({ ...prev, pageSize: params.pageSize, page: params.page }))}
                    
                sx={{
                    '& .MuiDataGrid-cell:focus-within': {
                        outline: 'none',
                        backgroundColor: 'none'
                    },
                    '& .MuiDataGrid-cell:hover': {
                        backgroundColor: 'none',
                    },
                    '& .checkin-header': {
                        backgroundColor: '#ccc',
                    },
                    '& .MuiDataGrid-row': {
                        cursor: 'pointer',
                    },
                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
                }}
            />
        </>
    );
};

export default CheckInDataGrid;